export const UPLOAD_IMAGE_TO_S3 = 'GIFTYA/UPLOAD_IMAGE_TO_S3';
export const RESET_UPLOAD_IMAGE_TO_S3 = 'GIFTYA/RESET_UPLOAD_IMAGE_TO_S3';
export const UPLOAD_YELP_IMAGE_TO_S3 = 'GIFTYA/UPLOAD_YELP_IMAGE_TO_S3';
export const RESET_UPLOAD_YELP_IMAGE_TO_S3 = 'GIFTYA/RESET_UPLOAD_YELP_IMAGE_TO_S3';


export const uploadImageToS3 = (payload, meta, error) => ({
    type: UPLOAD_IMAGE_TO_S3,
    payload,
    meta,
    error
});
export const resetUploadImageToS3 = (payload, meta, error) => ({
    type: RESET_UPLOAD_IMAGE_TO_S3,
    payload,
    meta,
    error
});

export const uploadYelpImageToS3 = (payload, meta, error) => ({
    type: UPLOAD_YELP_IMAGE_TO_S3,
    payload,
    meta,
    error
});
export const resetUploadYelpImageToS3 = (payload, meta, error) => ({
    type: RESET_UPLOAD_YELP_IMAGE_TO_S3,
    payload,
    meta,
    error
});